import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-premiere-feature-guest',
  templateUrl: './premiere-feature-guest.component.html',
  styleUrls: ['./premiere-feature-guest.component.css']
})
export class PremiereFeatureGuestComponent implements OnInit {

  @ViewChild('dialogTemplate') dialogTemplate: TemplateRef<any>;

  @Input('premiereDetails') premiereDetails:any;
  @Input('image') image:any;

  @Input('eventid') eventid: any;   //for symposium
  @Input('id') eventId: any;        //for spotlight
  spot = false
  show:any

  constructor(private dialog: MatDialog, private router:Router) { }

  ngOnInit(): void {
    if (this.show = !this.show)
      this.premiereDetails.cinejoyFeaturedGuests;
    else
      this.premiereDetails.featuredGuests;

      if (this.router.url.includes('more-info')) {
        this.spot = true
      }
      else{
        this.spot = false
      }
  }

  openFeaturedGuestDetails(details: any) {
    const dialogRef = this.dialog.open(this.dialogTemplate, {
      data: {
        image: details.imageUrl,
        name: details.name,
        title: details.title,
        bio: details.bio,
        companyName: details.companyName
      }
    });
  }

  areBothPresent(title, companyName): boolean {
    return title?.length > 0 && companyName?.length > 0;
  }

}
